export default {
  ext_id: {
    label: 'Sales Rep ID',
    required: true,
    valueKeys: ['$set', 'dist_ext_id'],
    filters: ['trim', 'uppercase'],
    validators: [
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'pre',
        params: [],
        alertCode: 'rep-id-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  n: {
    label: 'Sales Rep Name',
    required: true,
    valueKeys: ['__tmp', 'n'],
    filters: ['trim'],
    validators: [],
  },
  email: {
    label: 'Sales Rep Email',
    required: true,
    valueKeys: ['__tmp', 'email'],
    filters: ['trim', 'lowercase'],
    validators: [
      {
        validator: 'isEmail',
        type: 'post',
        params: [],
        alertCode: 'email-invalid',
        alertLevel: 'critical',
      },
      {
        validator: 'isExistyAndNotEmptyString',
        type: 'post',
        params: [],
        alertCode: 'email-invalid',
        alertLevel: 'critical',
      },
    ],
  },
  rep_region: {
    label: 'Sales Rep Region',
    required: false,
    valueKeys: ['$set', 'data.dist_rgn_l1'],
    filters: ['trim'],
    validators: [],
  },
  rep_subregion: {
    label: 'Sales Rep Subregion',
    required: false,
    valueKeys: ['$set', 'data.dist_rgn_l2'],
    filters: ['trim'],
    validators: [],
  },
  channels: {
    label: 'Sales Channel',
    required: false,
    valueKeys: ['$set', 'data.channel'],
    filters: ['trim'],
    validators: [],
  },
};



// WEBPACK FOOTER //
// ./src/configs/etl/reps/repsColumnsConfig.js